/**
 * Drawer Cart Script
**/
var DrawerCartHelper = {};
/**
 * Drawer Cart constructor.	 
 * @param {string} container - selector for the section container DOM element
**/

// Init
$(function() {
	var selectors = {
		addToCartBtn		: '.btn[name="add"]',
		quantity			: 'input[name="quantity"]',
		personalNote		: '#message',
		cartLogo			: '[data-cart-icon]:not(".oncartpage")',
		headerCount			: '[data-cart-icon] .cart-count',
		mobileHeaderCart	: '.menu .mobile-right-menu a.nav-item-cart',
		headerWrapper		: '.header-wrapper',
		footerWrapper		: '.footer-wrapper',
		drawerCart			: '.drawer-cart',
		underDrawerOverlay	: '.under-drawer-overlay',
		closeBtn			: '[data-close-drawer]',
		itemsWrapper		: '[data-items]',
		cartJSON			: '[data-cart-json]',
		footerWrapper		: '.footer-wrapper',
		inputUpdates		: '[name="updates[]"]',
		btnDelete			: '[data-btn-delete]',
		itemCount			: '[data-item-count]',
		loadingWrapper		: '[loading-wrapper]',
		totalSpan			: '[data-cart-total-price]',
		checkoutBtn			: '[data-checkout]',
		viewportHeight		: document.documentElement.clientHeight
	};
	
	function DrawerCart(container) {
		
		this.$container 			= $(container);
		this.namespace 				= '.drawerCart';
		var sectionId 				= this.$container.attr('data-section-id');
		this.cartJSON				= JSON.parse($(selectors.cartJSON, this.$container).html()) || false;
		
		// this.$addToCartBtn			= $(selectors.addToCartBtn);
		this.$cartIcon				= $(selectors.cartLogo);
		this.$headerCount			= $(selectors.headerCount);
		this.$drawerCart			= this.$container;
		this.$underDrawerOverlay	= this.$container.next(selectors.underDrawerOverlay);
		this.$closeBtn				= $(selectors.closeBtn, this.$container);
		this.$headerWrapper			= $(selectors.headerWrapper, this.$container);
		this.$footerWrapper			= $(selectors.footerWrapper, this.$container);
		this.$itemsWrapper			= $(selectors.itemsWrapper, this.$container);
		this.$footerWrapper			= $(selectors.footerWrapper, this.$container);
		this.$itemCount				= $(selectors.itemCount, this.$container);
		this.$loadingWrapper		= $(selectors.loadingWrapper, this.$container);
		this.$totalSpan				= $(selectors.totalSpan, this.$container);
		this.$checkoutBtn			= $(selectors.checkoutBtn, this.$container);
		this.$inputUpdates			= $(selectors.inputUpdates, this.$container);
		this.$body					= $('body');
		
		this.ppCheckStatus			= false; // Not go to go (Default)
		this.ppCheckSkipAdd 		= false;
		
		// Event Handlers \\
		this.$cartIcon.on('click', this.openDrawer.bind(this));
		this.$closeBtn.on('click', this.closeDrawer.bind(this));
	
		// Delete
		this.$container.on('click', selectors.btnDelete, this.clickedBtnDelete.bind(this));
		
		// Quantity input change
		this.$container.on('changeProg keyup', selectors.inputUpdates, this.qtyInputChange.bind(this));
		
		// Checkout
		this.$checkoutBtn.on('click', function(e) { 
			this.$checkoutBtn.attr('disabled', 'disabled').addClass('disabled'); 
		}.bind(this));

		// Click outside of the Drawer
		this.$underDrawerOverlay.on('click', this.closeDrawer.bind(this));
		
		// HELPER Function
		/**
		 * Returned Debouncing function
		 *
		 * @param {Integer} qty
		 * @param {Integer} variantid
		 * @param {Function} callback
		 * 
		**/
		DrawerCartHelper.returnedDebounceFunction = this.debounce(function() {
			var args = $.makeArray(arguments);
			  fn = args.pop();
			// Callback
			if (typeof fn === 'function')
				fn.apply(args); 
		}, 400);
		
		
		// Init
		this.setDrawerHeight( selectors.viewportHeight );
		this.windowResize();
		
		// Call a Init method that can also be called from post Ajax load
		this.init();
	}
		
	DrawerCart.prototype = $.extend({}, DrawerCart.prototype, {
		
		init: function() {
			this.$addToCartBtn = $(selectors.addToCartBtn);
			this.$addToCartBtn.on('click', this.addToCartAction.bind(this));
			
			this.PPCheckEvent(false);
		},
		
		/**
		 * Listen to Global Event for PP check
		 * True > all good, false > some warnings 
		 * skipAdd is for skipping prodcut already added by custom product
		 * @param {Boolean} status
		 * @param {Function} callback
		**/
		PPCheckEvent: function(callback) {
			$(document).one('ppCheck', function(event, status, skipAdd) {
				this.ppCheckStatus = status;
				this.ppCheckSkipAdd = skipAdd;
				if (callback && status === true)
					callback(status, skipAdd);
			});
		},
		
		/**
		 * On Window resize
		**/
		windowResize: function() {
			$(window).on('resize', function() {
				this.setDrawerHeight( document.documentElement.clientHeight );
			}.bind(this));
		},
		
		/**
		 * Get page position Y
		**/
		getPagePositionTop: function() {
			return this.pagePositionTop = this.pagePositionY = document.documentElement.scrollTop || document.body.scrollTop;
		},
		
		/**
		 * Set page position Y
		**/
		setPagePositionTop: function(y) {
			this.$body.css('top', y*-1);
			document.documentElement.scrollTop += document.body.scrollTop += y;
		},
		
		/**
		 * Get the viewport Height
		 * Apply it to the Drawer Cart Element
		 * @param {Integer} height
		**/
		setDrawerHeight: function(height) {
			var hHeight = this.$headerWrapper.outerHeight(), 
			  fHeight = this.$footerWrapper.outerHeight(),
			  wrapperHeight = height-(hHeight+fHeight+20);
			this.$drawerCart.height(height);
			this.$itemsWrapper.height(wrapperHeight);
		},
		
		/**
		 * Catch Add to cart btn actioon
		**/
		addToCartAction: function(e) {
			e.preventDefault();
			var $target = $(e.currentTarget),
			  variant_id = $target.data('variant-id'),
			  message = $(selectors.personalNote).val(),
			  self = this;
			
			if (!variant_id ) return;
				
			function proceed(status, skipAdd) {
				// Loading
				self.$loadingWrapper.addClass('on');
			
				// Open the Drawer
				self.setDrawerHeight( selectors.viewportHeight );
				self.openDrawer(null, skipAdd);
							
				var data = { 
					id: variant_id, 
					quantity: $(selectors.quantity).val(),
				};
				
				// Add to Cart
				self.addCartItem(data, function(item) {							
					self.buildItemsView();
				});
				
			};
			// If event already triggered and Status == true Proceed
			// else listen for event
			if (this.ppCheckStatus === true) {
				proceed(true, this.ppCheckSkipAdd);
			} else {
				this.PPCheckEvent(proceed);
			}
		},
		
		/**
		 * On Cart Icon Click
		 * Open the Drawer Cart
		**/
		openDrawer: function(e, skipAdd) {
			if (e) e.preventDefault();
			this.$underDrawerOverlay.addClass('open');
			this.$drawerCart.addClass('open');
			
			// if only opne cart, no items added to cart
			setTimeout(function() {
				this.$footerWrapper.addClass('slide');
			}.bind(this), 400);
			
			
			// Stop main page scroll
			this.setPagePositionTop( this.getPagePositionTop() );
			this.$body.addClass('no-scroll');
		},
		
		/**
		 * Close drawer
		**/
		closeDrawer: function(e) {
			if (e) e.preventDefault();
			this.$drawerCart.removeClass('open');
			this.$underDrawerOverlay.removeClass('open');
			setTimeout(function() {
				this.$footerWrapper.removeClass('slide');
			}.bind(this), 1250);
			
			// Stop main page scroll
			this.$body.removeClass('no-scroll');
			// Remove Loading
			this.$loadingWrapper.removeClass('on');
		},
		
		/**
		 * handle Quantity input changes
		 *
		 * @param {Event} e
		**/
		qtyInputChange: function(e) {
			var $target = $(e.currentTarget),
			  variant_id = $target.data('variant-id'),
			  original_qty = ~~$target.data('original-qty'),
			  qty = ~~$target.val();

			// No change occured return
			if (qty == original_qty) return;
			
			// Debounce
			DrawerCartHelper.returnedDebounceFunction(qty, variant_id, function() {
				var data = { updates: {} };
				
				// Set data update id: qty
				data.updates[variant_id] = qty;
				this.updateCartItem(data, function(cart) {
					
					// Update Total
					this.updateSubtotal(cart.items_subtotal_price);	
					
					var item_count = this.countCartItems(cart);				
					// Update original quantity
					$target.data('original-qty', item_count);
					this.updateItemCount(item_count);
				}.bind(this));
			}.bind(this));
		},
		
		/**
		 * Debouncing function
		 *
		 * @param {Function} func
		 * @param {Integer} wait
		 * @param {Boolean} immediate
		**/
		debounce: function(func, wait, immediate) {
			var timeout;
			return function() {
				var context = this, args = arguments;
				clearTimeout(timeout);
				// Moving this line above timeout assignment
				if (immediate && !timeout) func.apply(context, args);
				timeout = setTimeout(function() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				}, wait);
			};
		},
		
		/**
		 * Delete item button
		 * trigger link
		**/
		clickedBtnDelete: function(e) {
			e.preventDefault();
			var $target = $(e.currentTarget),
			  variant_id = $target.data('variant-id'),
			  data = { updates: {} };
			
			// Set data update id: qty
			data.updates[variant_id] = 0;
			
			this.updateCartItem(data, function(cart) {
				var $item = $('[data-item-id="'+variant_id+'"]');
				$item.addClass('fade');
				setTimeout(function() {
					$item.remove();
				}, 400);
				
				// Update cart total
				this.updateSubtotal(cart.items_subtotal_price);
				
				// Update original quantity
				var item_count = this.countCartItems(cart);
				$target.data('original-qty', item_count);
				this.updateItemCount(item_count);
				
				// If count becomes ZERO
				// Show empty cart message
				if (item_count === 0)
					this.buildItemsView();
				
			}.bind(this));
		},
		
		/**
		 * Count Cart Items
		 * Custom piece count for ONE item
		 * @param cart {Object}
		 * @return {Integer}
		**/
		countCartItems: function(cart) {
			var total = 0, i=0, len = cart.items.length || 0;
			
			for (i; i<len; i++) {
				if ( cart.items[i].properties !== null && typeof cart.items[i].properties.CUSTOM_ID !== 'undefined' )
					total++;
				else
					total = total+cart.items[i].quantity;
			}
			
			return total;
		},
		
		/**
		 * Update cart count
		 * @param {integer} count
		**/
		updateItemCount: function(count) {
			this.$itemCount.html('('+count+')');
			this.$headerCount.html('<span class="count">('+count+')</span>');
			
			if (count < 1) {
				$(selectors.mobileHeaderCart).removeClass('full-cart');
				this.$headerCount.parents('[data-cart-icon]').removeClass('on');
			} else {
				$(selectors.mobileHeaderCart).addClass('full-cart');
				this.$headerCount.parents('[data-cart-icon]').addClass('on');
			}
		},
		
		/**
		 * POST Ajax with cart update
		 * 0: to delete a variant
		 * returns full updated cart
		 *
		 * @param {Object} data
		 * @param {Function} callback
		 * @return {Object}
		**/
		addCartItem: function(data, callback) {	
			var self = this;
			
			$.ajax({
				type: 'POST',
				url: "/cart/add.js",
				data: data,
				dataType: 'json'
			})
			.done(function(cart) {
				if (typeof callback === "function") {
					callback(cart);
				}
			})
			.fail(function(e) {
				if (e.status == 422) {
					confirm('LIMITED QUANTITY: '+e.responseJSON.description);
					self.closeDrawer(null);
					
				}
			});
		},
		
		/**
		 * POST Ajax with cart update
		 * 0: to delete a variant
		 * returns full updated cart
		 *
		 * @param {Object} data
		 * @param {Function} callback
		 * @return {Object}
		**/
		updateCartItem: function(data, callback) {
			$.ajax({
				type: 'POST',
				url: "/cart/update.js",
				data: data,
				dataType: 'json'
			})
			.done(function(cart) {
				if (typeof callback === "function") {
					callback(cart);
				}
			})
			.fail(function(e){
				if (e.status == 422) {
					console.log(e.responseJSON.description);
				}
			});
		},
		
		/**
		 * POST Ajax with cart delete
		 *
		 * @param {Function} callback
		 * @return {Object}
		**/
		clearCartItems: function(callback) {
			$.ajax({
				type: 'POST',
				url: "/cart/clear.js",
				dataType: 'json'
			})
			.done(function(cart) {
				if (typeof callback === "function") {
					callback(cart);
				}
			})
			.fail(function(e){
				if (e.status == 422) {
					console.log(e.responseJSON.description);
				}
			});
		},	
		
		/**
		 * Build items view
		**/
		buildItemsView: function() {	
			$.get('/cart?view=drawer&timestamp='+Date.now())
			.done(function(res) {
				if (res)
					this.$itemsWrapper.parent('.items').empty().html(res);
				else
					this.$itemsWrapper.html('<div class="no-item d-flex align-self-center p-3">Sorry something went wrong, please try again.</div>').addClass('justify-content-center');
				
				// Set wrapper again after injection
				this.$itemsWrapper = $(selectors.itemsWrapper, this.$container); // Reset
				
				// Get the cart count
				this.updateItemCount( window.ajaxCartCount );

				// Set height
				this.setDrawerHeight( selectors.viewportHeight );
				
				// Remove Loading
				this.$loadingWrapper.removeClass('on');
				
				this.cartJSON = JSON.parse($(selectors.cartJSON, this.$container).html());
				this.updateSubtotal( this.cartJSON.total_price );
			}.bind(this))
			.fail(function() {
				console.log('DrawerCart::buildItemsView:fail');
			});
		},
		
		/**
		 * Update Subtotal
		 * @param {Integer} variantID
		 * @param {object} item
		**/
		updateItemSubtotal: function(variantID, item) {
			if ($.isEmptyObject(item) || !item.length) return;
			var price = (item[0].final_line_price == 0) ? "Free" : item[0].final_line_price;
			this.$itemsWrapper.find('[data-item-id="'+variantID+'"] [data-product-price]').text(Shopify.formatMoney(price));
		},
		
		/**
		 * Update Subtotal
		 * @param {Integer} total
		**/
		updateSubtotal: function(total) {
			this.$totalSpan.text(Shopify.formatMoney(total));
			this.$totalSpan.data('cart-total-price', total);
		}
		
	});

	new DrawerCart('#drawerCart');
	
});